import axios from 'axios';

// 환경에 따라 API URL 결정
const API_BASE_URL = (() => {
  // 프로덕션 환경인지 확인
  const isProduction = window.location.hostname === 'kidscafe.modouarena.com';
  
  if (isProduction) {
    // 프로덕션: 절대 경로 사용
    return 'https://kidscafe.modouarena.com/api';
  } else {
    // 개발: 프록시를 통한 로컬 백엔드 연결
    return '/api';
  }
})();

export interface Notice {
  id: number;
  title: string;
  content: string;
  author: string;
  category: string;
  is_pinned: boolean;
  view_count: number;
  image_url?: string;
  created_at: string;
  updated_at: string;
}

export interface NoticeFormData {
  title: string;
  content: string;
  author: string;
  category: string;
  is_pinned: boolean;
  image_url?: string;
}

class NoticeApi {
  private api = axios.create({
    baseURL: `${API_BASE_URL}/notices`,
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: false,
  });

  // 모든 공지사항 조회
  async getAll(): Promise<Notice[]> {
    const response = await this.api.get('/');
    return response.data;
  }

  // 특정 공지사항 조회
  async getOne(id: number): Promise<Notice> {
    const response = await this.api.get(`/${id}`);
    return response.data;
  }

  // 공지사항 생성
  async create(data: NoticeFormData): Promise<Notice> {
    const response = await this.api.post('/', { notice: data });
    return response.data;
  }

  // 공지사항 수정
  async update(id: number, data: Partial<NoticeFormData>): Promise<Notice> {
    const response = await this.api.patch(`/${id}`, { notice: data });
    return response.data;
  }

  // 공지사항 삭제
  async delete(id: number): Promise<void> {
    await this.api.delete(`/${id}`);
  }
}

export default new NoticeApi();